<template>
  <div class="support-container">
    <h1>Assistenza</h1>
    <p class="subtitle">
      Hai bisogno di aiuto? Contattaci tramite uno dei seguenti canali.
    </p>

    <div class="contact-card">
      <h2>📧 Email</h2>
      <p>
        <a :href="'mailto:' + email">{{ email }}</a>
      </p>
    </div>

    <div class="contact-card">
      <h2>📞 Telefono</h2>
      <p>
        <a :href="'tel:' + phone">{{ phone }}</a>
      </p>
    </div>

    <div class="contact-card">
      <h2>🕒 Orari di Assistenza</h2>
      <p>Lunedì - Venerdì</p>
      <p>10:00 - 18:00</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SupportView",
  data() {
    return {
      email: "info@centrofitnesskinesis.it",
      phone: "+39 3313216669",
    };
  }
};
</script>

<style scoped>
.support-container {
  max-width: 800px;
  margin: 40px auto;
  padding: 20px;
  text-align: center;
}

.subtitle {
  margin-bottom: 30px;
  color: #666;
}

.contact-card {
  background: #f5f5f5;
  padding: 20px;
  margin-bottom: 20px;
  border-radius: 10px;
  transition: 0.3s ease;
}

.contact-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-3px);
}

a {
  color: #42b983;
  text-decoration: none;
  font-weight: bold;
}

a:hover {
  text-decoration: underline;
}
</style>